    <header id="main-header">
        <app-header></app-header>
    </header>

    <main id="main-container" tabindex="-1" role="main">
      <router-outlet />
    </main>

    <footer id="main-footer" class="site-footer" role="contentinfo">
        <app-footer></app-footer>
    </footer>